module.exports = __webpack_public_path__ + "static/media/map-marker-vaccination-place-active.bbf39311.svg";